module.exports = __webpack_public_path__ + "static/media/PlusCircle.ed8363ae.svg";